const LOWERCASE_PARTICLES = new Set([
  "da",
  "das",
  "de",
  "di",
  "do",
  "dos",
  "du",
  "e",
  "la",
  "le",
  "van",
  "von",
]);

const capitalizeToken = (token = "") => {
  if (!token) return "";

  return token
    .split("-")
    .map((part) =>
      part ? `${part.charAt(0).toUpperCase()}${part.slice(1).toLowerCase()}` : ""
    )
    .join("-");
};

export const formatPersonName = (value) => {
  const normalized = String(value || "")
    .trim()
    .replace(/\s+/g, " ");

  if (!normalized) return "";

  return normalized
    .split(" ")
    .map((token, index) => {
      const lower = token.toLowerCase();
      if (index > 0 && LOWERCASE_PARTICLES.has(lower)) {
        return lower;
      }
      return capitalizeToken(token);
    })
    .join(" ");
};
